import FiltersDisplayConditionsGroup from './FiltersDisplayConditionsGroup';
import LogicGroupsDivider from '../common/LogicGroupsDivider';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FiltersDisplayTopLevelLogicGroupItem = props => {
  const {
    logicGroupIndex,
    logicGroup,
    logicOperator
  } = props;
  return /*#__PURE__*/_jsxs("div", {
    children: [logicGroupIndex !== 0 && /*#__PURE__*/_jsx(LogicGroupsDivider, {
      logicOperator: logicOperator
    }), /*#__PURE__*/_jsx(FiltersDisplayConditionsGroup, {
      logicGroup: logicGroup,
      logicGroupIndex: logicGroupIndex
    })]
  });
};
export default FiltersDisplayTopLevelLogicGroupItem;